//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: "ButtonMenu",
	props: {
		title: {
			type: String,
			required: true,
		},
		list: {
			type: Array,
			required: true,
		},
		listActive: {
			type: Array,
			required: true,
		},
		listElementTitleProperty: {
			type: String,
			required: false,
		},
		listElementComparisonProperty: {
			type: String,
			required: false,
		},
		listElementCallback: {
			type: Function,
			required: true,
		},
	},
	data() {
		return {
			open: false,
		};
	},
	computed: {
		buttonTitle() {
			if (this.listActive.length === 0) {
				return this.title;
			} else {
				return `${this.title} (${this.listActive.length})`;
			}
		}
	},
	methods: {
		_getString(i) {
			return this.listElementTitleProperty
				? i[this.listElementTitleProperty]
				: i;
		},
		toggleMenu() {
			this.open = !this.open;
			if (this.open) this.closeOutside();
		},
		isActive(i) {
			return this.listActive.find((e) => {
				if (this.listElementComparisonProperty) {
					return e === i[this.listElementComparisonProperty];
				} else {
					return e === i;
				}
			});
		},
		toggleListElement(element) {
			this.listElementCallback(element);
		},
		closeOutside(e) {
			// close if clicked outside
		},
	},
};
